module.exports = __webpack_public_path__ + "f8ef9d256ad582d58c8b471a8080f103.pdf";